module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-4_LT-13934db7d162d6d8435ee60ae9800cf2.svg";